import { makeAutoObservable, runInAction } from "mobx";
import Parse from "parse";
import { Agency } from "../js/parsegenerated";

export class AgencyState {
  public agencies: Agency[] = [];
  public selectedAgency: Agency = null;
  public loading: boolean = false;

  constructor() {
    makeAutoObservable(this);

    this.fetchAgencies();
  }

  private async fetchAgencies() {
    this.loading = true;
    await new Parse.Query(Agency)
      .ascending("agency_name")
      .find()
      .then((values) => {
        runInAction(() => {
          this.agencies = values;
          this.selectedAgency = values[0];
        });
      });
    runInAction(() => {
      this.loading = false;
    });
  }
}
